var _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _g3, _path8, _g4, _path9, _g5, _path10, _g6, _path11, _g7, _path12, _g8, _path13, _g9, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g10, _path26, _path27, _path28, _g11, _path29, _g12, _path30, _g13, _path31, _g14, _path32, _g15, _path33, _g16, _path34, _g17, _path35, _path36, _path37, _path38, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 53,
    viewBox: "0 0 63 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_4014_279705)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4014_279705)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.99103,
    cy: 13.447,
    rx: 6.99103,
    ry: 13.447,
    transform: "matrix(0.756056 0.654507 -0.895909 0.444237 31.998 22.6758)",
    fill: "#1FD969"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4014_279705)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.99103,
    cy: 11.0821,
    rx: 6.99103,
    ry: 11.0821,
    transform: "matrix(-0.756056 0.654507 0.895909 0.444237 34.1431 21.2402)",
    fill: "#1FD969"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4014_279705)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.6957,
    cy: 22.9813,
    rx: 14.2265,
    ry: 10.7548,
    fill: "#1FD969"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9292 36.0322C38.2744 36.3405 37.5807 36.7524 36.8953 37.2558C36.2098 37.7599 35.6095 38.2987 35.1198 38.8314L32.6978 40.611L33.8723 42.0004C34.5373 42.9055 36.9689 42.248 39.303 40.5325C41.6371 38.8171 42.9903 36.6931 42.3253 35.788L41.3499 34.252L38.9292 36.0322Z",
    fill: "url(#paint0_linear_4014_279705)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3502 34.2524C41.9955 35.1302 40.5815 37.2658 38.1922 39.0214C35.8029 40.7771 33.3426 41.4892 32.6974 40.6114C32.0521 39.7335 33.5834 37.7739 35.9727 36.0183C38.3627 34.2619 40.705 33.3745 41.3502 34.2524Z",
    fill: "url(#paint1_linear_4014_279705)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6969 36.3701C38.9813 37.001 38.0605 38.2137 36.6138 38.8651C35.1672 39.5165 33.7423 39.361 33.4579 38.7294C33.1734 38.0985 34.1666 37.1831 35.6132 36.5317C37.0599 35.8797 38.4125 35.7385 38.6969 36.3701Z",
    fill: "url(#paint2_linear_4014_279705)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6594 36.2025C38.6246 36.1554 38.5803 36.1179 38.5264 36.0885L36.9304 34.5361L35.6064 35.4829L35.5976 35.4897L35.5887 35.4965L34.29 36.4773L35.2947 38.4642C35.3063 38.5236 35.3288 38.5781 35.3636 38.6245C35.6474 39.0106 36.6152 38.7807 37.5251 38.1116C38.4343 37.4438 38.9425 36.5885 38.6594 36.2025Z",
    fill: "url(#paint3_linear_4014_279705)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 34,
    width: 5,
    height: 5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6594 36.2034C38.6246 36.1564 38.5803 36.1188 38.5264 36.0895L36.9304 34.5371L35.6064 35.4838L35.5976 35.4907L35.5887 35.4975L34.29 36.4783L35.2947 38.4652C35.3063 38.5245 35.3288 38.5791 35.3636 38.6255C35.6474 39.0115 36.6152 38.7817 37.5251 38.1126C38.4343 37.4448 38.9425 36.5895 38.6594 36.2034Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4037 34.111C37.8669 34.8443 37.1718 36.115 35.8513 36.9498C34.5308 37.7847 33.0841 37.8672 32.621 37.134C32.1579 36.4008 32.8529 35.1301 34.1734 34.2952C35.4939 33.4603 36.9406 33.3778 37.4037 34.111Z",
    fill: "url(#paint4_radial_4014_279705)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1004 29.1578L31.629 16.0933C31.6017 16.023 31.5676 15.9576 31.5232 15.8982C31.4005 15.7311 31.2313 15.4187 31.0124 15.1418L30.8794 14.9365L30.8787 14.9385C30.8787 14.9385 30.878 14.9379 30.878 14.9372C30.0384 13.794 26.3449 15.0811 22.6296 17.8115C18.9144 20.5418 16.583 23.6821 17.4233 24.8246L17.424 24.8253H17.422L17.5816 25.0176C17.7794 25.3075 18.0249 25.5605 18.147 25.727C18.192 25.7877 18.2452 25.8416 18.3053 25.8886L27.9928 37.5549L28.0426 37.5569C28.0774 37.6776 28.1306 37.7888 28.2036 37.8877C29.0848 39.0875 32.4618 38.1033 35.7453 35.6908C39.0227 33.2837 40.9687 30.3617 40.1004 29.1578ZM32.5532 31.348C30.7805 32.6507 29.4729 34.0115 28.7138 35.2617L21.5022 25.6383C22.9236 25.0988 24.6295 24.1527 26.3388 22.8963C26.3449 22.8922 26.3504 22.8875 26.3565 22.8834C26.3626 22.8793 26.3681 22.8745 26.3742 22.8704C28.0835 21.614 29.4954 20.269 30.4353 19.0733L37.5828 28.7997C36.1573 29.1442 34.3423 30.0336 32.5532 31.348Z",
    fill: "url(#paint5_linear_4014_279705)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 14,
    width: 24,
    height: 25
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1004 29.1573L31.629 16.0928C31.6017 16.0226 31.5676 15.9571 31.5232 15.8977C31.4005 15.7306 31.2313 15.4182 31.0124 15.1413L30.8794 14.936L30.8787 14.9381C30.8787 14.9381 30.878 14.9374 30.878 14.9367C30.0384 13.7935 26.3449 15.0806 22.6296 17.811C18.9144 20.5413 16.583 23.6816 17.4233 24.8241L17.424 24.8248H17.422L17.5816 25.0171C17.7794 25.307 18.0249 25.5601 18.147 25.7265C18.192 25.7872 18.2452 25.8411 18.3053 25.8881L27.9928 37.5544L28.0426 37.5564C28.0774 37.6772 28.1306 37.7883 28.2036 37.8872C29.0848 39.087 32.4618 38.1028 35.7453 35.6903C39.0227 33.2832 40.9687 30.3612 40.1004 29.1573ZM32.5532 31.3475C30.7805 32.6502 29.4729 34.011 28.7138 35.2612L21.5022 25.6378C22.9236 25.0983 24.6295 24.1522 26.3388 22.8959C26.3449 22.8918 26.3504 22.887 26.3565 22.8829C26.3626 22.8788 26.3681 22.874 26.3742 22.8699C28.0835 21.6135 29.4954 20.2685 30.4353 19.0728L37.5828 28.7992C36.1573 29.1437 34.3423 30.0331 32.5532 31.3475Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9746 31.7319L37.9083 34.4166L40.08 32.0464L40.4667 30.7613L30.2929 15.9111C30.2929 15.9111 28.8052 18.31 28.2105 18.6524C27.6157 18.9955 35.9746 31.7319 35.9746 31.7319Z",
    fill: "url(#paint6_linear_4014_279705)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 14,
    width: 24,
    height: 25
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1004 29.1573L31.629 16.0928C31.6017 16.0226 31.5676 15.9571 31.5232 15.8977C31.4005 15.7306 31.2313 15.4182 31.0124 15.1413L30.8794 14.936L30.8787 14.9381C30.8787 14.9381 30.878 14.9374 30.878 14.9367C30.0384 13.7935 26.3449 15.0806 22.6296 17.811C18.9144 20.5413 16.583 23.6816 17.4233 24.8241L17.424 24.8248H17.422L17.5816 25.0171C17.7794 25.307 18.0249 25.5601 18.147 25.7265C18.192 25.7872 18.2452 25.8411 18.3053 25.8881L27.9928 37.5544L28.0426 37.5564C28.0774 37.6772 28.1306 37.7883 28.2036 37.8872C29.0848 39.087 32.4618 38.1028 35.7453 35.6903C39.0227 33.2832 40.9687 30.3612 40.1004 29.1573ZM32.5532 31.3475C30.7805 32.6502 29.4729 34.011 28.7138 35.2612L21.5022 25.6378C22.9236 25.0983 24.6295 24.1522 26.3388 22.8959C26.3449 22.8918 26.3504 22.887 26.3565 22.8829C26.3626 22.8788 26.3681 22.874 26.3742 22.8699C28.0835 21.6135 29.4954 20.2685 30.4353 19.0728L37.5828 28.7992C36.1573 29.1437 34.3423 30.0331 32.5532 31.3475Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.979 17.7685C38.6684 22.6379 38.2073 29.2001 33.9504 32.425C29.6936 35.6499 23.2514 34.3178 19.562 29.4484C15.8726 24.5791 16.3337 18.0168 20.5906 14.7919C24.8474 11.5671 31.2903 12.8992 34.979 17.7685Z",
    fill: "url(#paint7_radial_4014_279705)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 14,
    width: 24,
    height: 25
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1004 29.1573L31.629 16.0928C31.6017 16.0226 31.5676 15.9571 31.5232 15.8977C31.4005 15.7306 31.2313 15.4182 31.0124 15.1413L30.8794 14.936L30.8787 14.9381C30.8787 14.9381 30.878 14.9374 30.878 14.9367C30.0384 13.7935 26.3449 15.0806 22.6296 17.811C18.9144 20.5413 16.583 23.6816 17.4233 24.8241L17.424 24.8248H17.422L17.5816 25.0171C17.7794 25.307 18.0249 25.5601 18.147 25.7265C18.192 25.7872 18.2452 25.8411 18.3053 25.8881L27.9928 37.5544L28.0426 37.5564C28.0774 37.6772 28.1306 37.7883 28.2036 37.8872C29.0848 39.087 32.4618 38.1028 35.7453 35.6903C39.0227 33.2832 40.9687 30.3612 40.1004 29.1573ZM32.5532 31.3475C30.7805 32.6502 29.4729 34.011 28.7138 35.2612L21.5022 25.6378C22.9236 25.0983 24.6295 24.1522 26.3388 22.8959C26.3449 22.8918 26.3504 22.887 26.3565 22.8829C26.3626 22.8788 26.3681 22.874 26.3742 22.8699C28.0835 21.6135 29.4954 20.2685 30.4353 19.0728L37.5828 28.7992C36.1573 29.1437 34.3423 30.0331 32.5532 31.3475Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.062 27.8267C39.8668 28.9671 37.5989 31.9539 33.9955 34.4988C30.3921 37.0436 26.8187 38.182 26.0138 37.0416C25.209 35.9011 27.4769 32.9143 31.0803 30.3695C34.6837 27.8253 38.2571 26.6869 39.062 27.8267Z",
    fill: "url(#paint8_radial_4014_279705)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 14,
    width: 24,
    height: 25
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1004 29.1573L31.629 16.0928C31.6017 16.0226 31.5676 15.9571 31.5232 15.8977C31.4005 15.7306 31.2313 15.4182 31.0124 15.1413L30.8794 14.936L30.8787 14.9381C30.8787 14.9381 30.878 14.9374 30.878 14.9367C30.0384 13.7935 26.3449 15.0806 22.6296 17.811C18.9144 20.5413 16.583 23.6816 17.4233 24.8241L17.424 24.8248H17.422L17.5816 25.0171C17.7794 25.307 18.0249 25.5601 18.147 25.7265C18.192 25.7872 18.2452 25.8411 18.3053 25.8881L27.9928 37.5544L28.0426 37.5564C28.0774 37.6772 28.1306 37.7883 28.2036 37.8872C29.0848 39.087 32.4618 38.1028 35.7453 35.6903C39.0227 33.2832 40.9687 30.3612 40.1004 29.1573ZM32.5532 31.3475C30.7805 32.6502 29.4729 34.011 28.7138 35.2612L21.5022 25.6378C22.9236 25.0983 24.6295 24.1522 26.3388 22.8959C26.3449 22.8918 26.3504 22.887 26.3565 22.8829C26.3626 22.8788 26.3681 22.874 26.3742 22.8699C28.0835 21.6135 29.4954 20.2685 30.4353 19.0728L37.5828 28.7992C36.1573 29.1437 34.3423 30.0331 32.5532 31.3475Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M18.2515 24.9856L30.1374 39.505L34.1589 36.969L24.337 22.6011L18.2515 24.9856Z",
    fill: "url(#paint9_linear_4014_279705)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 14,
    width: 24,
    height: 25
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1004 29.1573L31.629 16.0928C31.6017 16.0226 31.5676 15.9571 31.5232 15.8977C31.4005 15.7306 31.2313 15.4182 31.0124 15.1413L30.8794 14.936L30.8787 14.9381C30.8787 14.9381 30.878 14.9374 30.878 14.9367C30.0384 13.7935 26.3449 15.0806 22.6296 17.811C18.9144 20.5413 16.583 23.6816 17.4233 24.8241L17.424 24.8248H17.422L17.5816 25.0171C17.7794 25.307 18.0249 25.5601 18.147 25.7265C18.192 25.7872 18.2452 25.8411 18.3053 25.8881L27.9928 37.5544L28.0426 37.5564C28.0774 37.6772 28.1306 37.7883 28.2036 37.8872C29.0848 39.087 32.4618 38.1028 35.7453 35.6903C39.0227 33.2832 40.9687 30.3612 40.1004 29.1573ZM32.5532 31.3475C30.7805 32.6502 29.4729 34.011 28.7138 35.2612L21.5022 25.6378C22.9236 25.0983 24.6295 24.1522 26.3388 22.8959C26.3449 22.8918 26.3504 22.887 26.3565 22.8829C26.3626 22.8788 26.3681 22.874 26.3742 22.8699C28.0835 21.6135 29.4954 20.2685 30.4353 19.0728L37.5828 28.7992C36.1573 29.1437 34.3423 30.0331 32.5532 31.3475Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6753 25.9908L28.6072 36.0358L29.4079 35.7684L22.0947 25.4131L20.6753 25.9908Z",
    fill: "url(#paint10_linear_4014_279705)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 14,
    width: 24,
    height: 25
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1004 29.1573L31.629 16.0928C31.6017 16.0226 31.5676 15.9571 31.5232 15.8977C31.4005 15.7306 31.2313 15.4182 31.0124 15.1413L30.8794 14.936L30.8787 14.9381C30.8787 14.9381 30.878 14.9374 30.878 14.9367C30.0384 13.7935 26.3449 15.0806 22.6296 17.811C18.9144 20.5413 16.583 23.6816 17.4233 24.8241L17.424 24.8248H17.422L17.5816 25.0171C17.7794 25.307 18.0249 25.5601 18.147 25.7265C18.192 25.7872 18.2452 25.8411 18.3053 25.8881L27.9928 37.5544L28.0426 37.5564C28.0774 37.6772 28.1306 37.7883 28.2036 37.8872C29.0848 39.087 32.4618 38.1028 35.7453 35.6903C39.0227 33.2832 40.9687 30.3612 40.1004 29.1573ZM32.5532 31.3475C30.7805 32.6502 29.4729 34.011 28.7138 35.2612L21.5022 25.6378C22.9236 25.0983 24.6295 24.1522 26.3388 22.8959C26.3449 22.8918 26.3504 22.887 26.3565 22.8829C26.3626 22.8788 26.3681 22.874 26.3742 22.8699C28.0835 21.6135 29.4954 20.2685 30.4353 19.0728L37.5828 28.7992C36.1573 29.1437 34.3423 30.0331 32.5532 31.3475Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.307 17.9941L37.9218 27.8952L37.3884 29.2566L30.2798 19.4347L31.307 17.9941Z",
    fill: "url(#paint11_linear_4014_279705)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 14,
    width: 24,
    height: 25
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1004 29.1573L31.629 16.0928C31.6017 16.0226 31.5676 15.9571 31.5232 15.8977C31.4005 15.7306 31.2313 15.4182 31.0124 15.1413L30.8794 14.936L30.8787 14.9381C30.8787 14.9381 30.878 14.9374 30.878 14.9367C30.0384 13.7935 26.3449 15.0806 22.6296 17.811C18.9144 20.5413 16.583 23.6816 17.4233 24.8241L17.424 24.8248H17.422L17.5816 25.0171C17.7794 25.307 18.0249 25.5601 18.147 25.7265C18.192 25.7872 18.2452 25.8411 18.3053 25.8881L27.9928 37.5544L28.0426 37.5564C28.0774 37.6772 28.1306 37.7883 28.2036 37.8872C29.0848 39.087 32.4618 38.1028 35.7453 35.6903C39.0227 33.2832 40.9687 30.3612 40.1004 29.1573ZM32.5532 31.3475C30.7805 32.6502 29.4729 34.011 28.7138 35.2612L21.5022 25.6378C22.9236 25.0983 24.6295 24.1522 26.3388 22.8959C26.3449 22.8918 26.3504 22.887 26.3565 22.8829C26.3626 22.8788 26.3681 22.874 26.3742 22.8699C28.0835 21.6135 29.4954 20.2685 30.4353 19.0728L37.5828 28.7992C36.1573 29.1437 34.3423 30.0331 32.5532 31.3475Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0824 15.2795C31.922 16.4226 29.5914 19.5622 25.8761 22.2926C22.1608 25.0229 18.468 26.31 17.6277 25.1669C16.7881 24.0237 19.1187 20.8841 22.834 18.1537C26.5493 15.4234 30.2427 14.1363 31.0824 15.2795Z",
    fill: "url(#paint12_linear_4014_279705)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8778 14.9386C31.7174 16.0818 29.3868 19.2214 25.6715 21.9518C21.9562 24.6821 18.2635 25.9692 17.4231 24.826C16.5835 23.6829 18.9142 20.5433 22.6294 17.8129C26.3447 15.0826 30.0382 13.7955 30.8778 14.9386Z",
    fill: "url(#paint13_linear_4014_279705)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8778 14.9386C31.7174 16.0818 29.3868 19.2214 25.6715 21.9518C21.9562 24.6821 18.2635 25.9692 17.4231 24.826C16.5835 23.6829 18.9142 20.5433 22.6294 17.8129C26.3447 15.0826 30.0382 13.7955 30.8778 14.9386Z",
    fill: "url(#paint14_radial_4014_279705)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5877 16.2682C27.0058 16.8371 25.8313 18.41 23.9644 19.7816C22.0976 21.1533 20.2458 21.8047 19.8276 21.2358C19.4095 20.6669 20.5841 19.0941 22.4509 17.7224C24.3178 16.3508 26.1696 15.6994 26.5877 16.2682Z",
    fill: "url(#paint15_linear_4014_279705)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8582 13.1025L20.1768 14.4749L18.3652 15.6699C18.3652 15.6699 19.8808 21.0085 19.9361 21.0842C20.3439 21.6394 22.1569 20.9996 23.9849 19.6566C25.8128 18.3129 26.9642 16.7742 26.5563 16.219C26.5011 16.1432 21.8582 13.1025 21.8582 13.1025Z",
    fill: "url(#paint16_linear_4014_279705)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9741 14.6303L24.7105 19.061C24.7105 19.061 26.205 17.7132 26.2589 17.3927C26.3162 17.0503 21.8151 13.6562 21.8151 13.6562L21.4284 14.1057L20.9741 14.6303Z",
    fill: "url(#paint17_linear_4014_279705)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9361 21.0843C19.9361 21.0843 20.1646 21.5522 21.4455 21.0543C21.601 20.9936 19.0344 15.6543 19.0344 15.6543L18.4116 15.7703L19.9361 21.0843Z",
    fill: "url(#paint18_linear_4014_279705)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8867 13.1482C22.0995 13.4374 21.4883 14.2477 20.5218 14.9584C19.5553 15.6685 18.5997 16.0095 18.3869 15.7203C18.1741 15.4311 18.8862 14.7272 19.8527 14.0165C20.8192 13.3065 21.6739 12.859 21.8867 13.1482Z",
    fill: "url(#paint19_linear_4014_279705)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7269 13.9429C20.8047 14.0487 20.5775 14.3474 20.2201 14.61C19.8627 14.8726 19.5094 15.0002 19.4316 14.8944C19.3539 14.7887 19.6178 14.5289 19.9752 14.2663C20.3333 14.003 20.6491 13.8372 20.7269 13.9429Z",
    fill: "url(#paint20_linear_4014_279705)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9278 10.3635L15.7656 9.18555C15.7656 9.18555 19.4809 14.8359 19.4836 14.84C19.5443 14.9225 19.8663 14.7895 20.2019 14.5426C20.5374 14.2957 20.7605 14.0283 20.6998 13.9458C20.697 13.9424 17.9278 10.3635 17.9278 10.3635Z",
    fill: "url(#paint21_linear_4014_279705)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9052 9.69548C17.5034 10.0201 17.9679 10.3203 17.9427 10.3666C17.9175 10.413 17.3943 10.3373 16.7961 10.0126C16.1979 9.68798 15.7512 9.23781 15.7764 9.19142C15.8016 9.14573 16.3071 9.37149 16.9052 9.69548Z",
    fill: "url(#paint22_linear_4014_279705)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7773 28.627C39.7773 28.627 40.0283 29.9345 39.1328 31.2011C39.0195 31.3607 39.2371 32.3538 39.2371 32.3538C39.2371 32.3538 45.0395 33.0339 46.315 30.0982C46.5169 29.6337 46.403 29.206 46.328 28.9707C46.2884 28.8473 46.1697 28.7668 46.0402 28.7736L43.0527 28.9352C41.3263 29.026 39.7773 28.627 39.7773 28.627Z",
    fill: "url(#paint23_linear_4014_279705)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 28,
    width: 8,
    height: 5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7773 28.6279C39.7773 28.6279 40.0283 29.9355 39.1328 31.2021C39.0195 31.3617 39.2371 32.3548 39.2371 32.3548C39.2371 32.3548 45.0395 33.0348 46.315 30.0992C46.5169 29.6347 46.403 29.207 46.328 28.9717C46.2884 28.8482 46.1697 28.7678 46.0402 28.7746L43.0527 28.9362C41.3263 29.0269 39.7773 28.6279 39.7773 28.6279Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.502 31.1791C38.502 31.1791 41.4697 31.278 43.1319 31.0304C44.5015 30.8258 46.8247 29.5714 46.1596 28.8054C45.2143 27.7168 47.931 29.1942 47.931 29.1942C47.931 29.1942 48.1547 31.207 48.0886 31.2562C48.0217 31.3053 39.937 33.0964 39.937 33.0964L38.667 32.9027L38.502 31.1791Z",
    fill: "url(#paint24_linear_4014_279705)"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8781 27.8191C37.196 26.8915 34.2269 27.9153 31.2455 30.1061C29.5444 31.3564 28.2744 32.6312 27.5664 33.7409L29.1679 35.8492C30.4086 35.4659 32.1186 34.6399 33.7153 33.4661C36.696 31.2752 38.5601 28.7468 37.8781 27.8191Z",
    fill: "url(#paint25_linear_4014_279705)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8269 37.4092C27.8269 37.4092 28.9994 38.0394 30.4761 37.5626C30.6623 37.5026 31.5456 38.0067 31.5456 38.0067C31.5456 38.0067 30.4618 43.7477 27.2792 44.0881C26.7758 44.142 26.4014 43.906 26.1995 43.7634C26.0931 43.6884 26.0522 43.5513 26.0972 43.4299L27.1435 40.6265C27.7451 39.0059 27.8269 37.4092 27.8269 37.4092Z",
    fill: "url(#paint26_linear_4014_279705)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 37,
    width: 6,
    height: 8
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8269 37.4092C27.8269 37.4092 28.9994 38.0394 30.4761 37.5626C30.6623 37.5026 31.5456 38.0067 31.5456 38.0067C31.5456 38.0067 30.4618 43.7477 27.2792 44.0881C26.7758 44.142 26.4014 43.906 26.1995 43.7634C26.0931 43.6884 26.0522 43.5513 26.0972 43.4299L27.1435 40.6265C27.7451 39.0059 27.8269 37.4092 27.8269 37.4092Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6427 36.9536C30.6427 36.9536 29.8508 39.8156 29.1175 41.3278C28.5132 42.5739 26.6225 44.4169 26.0898 43.5527C25.3334 42.3257 25.9315 45.3595 25.9315 45.3595C25.9315 45.3595 27.7854 46.1746 27.8523 46.1255C27.9191 46.0764 32.043 38.8955 32.043 38.8955L32.2367 37.6255L30.6427 36.9536Z",
    fill: "url(#paint27_linear_4014_279705)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 17,
    width: 17,
    height: 18
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.502 25.6392C21.502 25.6392 24.0884 24.7511 26.979 22.4511C29.3274 20.5829 31.3068 17.9951 31.3068 17.9951L36.8808 27.9228C36.8808 27.9228 37.2013 28.8033 36.8276 29.5775C36.4538 30.3516 34.3455 32.567 32.984 33.3405C31.6233 34.1147 29.4611 34.6221 29.4611 34.6221L23.8026 28.7235L21.502 25.6392Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9653 22.3524L19.5312 26.0077C19.5312 26.0077 24.2239 27.8616 26.5089 29.8205C28.1855 31.2577 29.7638 33.0645 29.7638 33.0645L32.3918 31.1328L32.4252 31.1083L35.054 29.1773C35.054 29.1773 33.801 27.1311 32.93 25.1019C31.7432 22.3361 31.3748 17.3037 31.3748 17.3037L25.9653 22.3524Z",
    fill: "url(#paint28_radial_4014_279705)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 21,
    width: 16,
    height: 15
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.312 33.2064C20.312 33.2064 21.8702 30.9592 22.8374 27.394C23.6234 24.4979 23.6859 21.2404 23.6859 21.2404L34.0565 25.9392C34.0565 25.9392 34.8363 26.459 34.9936 27.3041C35.1509 28.1493 34.7639 31.183 34.125 32.6125C33.4869 34.0421 32.0452 35.7315 32.0452 35.7315L23.9924 34.3294L20.312 33.2064Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1127 32.1426C34.6307 31.0269 35.5633 29.717 35.1957 29.2168C34.828 28.7165 33.2994 29.2154 31.7814 30.331C30.2633 31.4467 29.3307 32.7566 29.6984 33.2568C30.066 33.7571 31.5947 33.2582 33.1127 32.1426Z",
    fill: "#005656"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 17,
    width: 17,
    height: 18
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.502 25.6392C21.502 25.6392 24.0884 24.7511 26.979 22.4511C29.3274 20.5829 31.3068 17.9951 31.3068 17.9951L36.8808 27.9228C36.8808 27.9228 37.2013 28.8033 36.8276 29.5775C36.4538 30.3516 34.3455 32.567 32.984 33.3405C31.6233 34.1147 29.4611 34.6221 29.4611 34.6221L23.8026 28.7235L21.502 25.6392Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1814 22.6904H25.3701L19.5322 26.0074C19.5322 26.0074 24.2249 27.8613 26.5099 29.8202C28.1864 31.2573 29.7648 33.0641 29.7648 33.0641L32.3928 31.1325L32.4262 31.108L35.0543 29.177C35.0543 29.177 33.8013 27.1308 32.9303 25.1016C32.6308 24.4031 32.3833 23.5608 32.1814 22.6904Z",
    fill: "url(#paint29_linear_4014_279705)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 17,
    width: 17,
    height: 18
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M21.502 25.6392C21.502 25.6392 24.0884 24.7511 26.979 22.4511C29.3274 20.5829 31.3068 17.9951 31.3068 17.9951L36.8808 27.9228C36.8808 27.9228 37.2013 28.8033 36.8276 29.5775C36.4538 30.3516 34.3455 32.567 32.984 33.3405C31.6233 34.1147 29.4611 34.6221 29.4611 34.6221L23.8026 28.7235L21.502 25.6392Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2009 22.8422C32.3469 23.9444 29.5408 25.2261 25.9326 25.7049C22.3244 26.1837 19.281 25.679 19.1344 24.5767C18.9884 23.4745 21.7945 22.1929 25.4026 21.714C29.0108 21.2352 32.0543 21.74 32.2009 22.8422Z",
    fill: "url(#paint30_linear_4014_279705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2011 22.8421C32.2209 22.9929 32.182 23.1457 32.1131 23.2793C32.0449 23.4144 31.9467 23.5324 31.841 23.6395C31.7898 23.6947 31.7305 23.7425 31.6753 23.7936C31.6152 23.84 31.5586 23.8898 31.4966 23.9328C31.4358 23.9771 31.3738 24.0208 31.3097 24.061C31.2469 24.1033 31.1821 24.1415 31.1173 24.1804C30.5962 24.4866 30.0355 24.7199 29.4653 24.9197C28.3235 25.3181 27.1374 25.5814 25.9403 25.756C24.7426 25.9244 23.5285 26.0083 22.3144 25.9422C21.7087 25.904 21.1003 25.8358 20.5069 25.6768C20.4326 25.6564 20.3589 25.6366 20.2859 25.6114C20.2123 25.5889 20.1393 25.5629 20.067 25.535C19.994 25.5097 19.9231 25.4756 19.8514 25.4456C19.7819 25.4102 19.7103 25.3788 19.6427 25.3372C19.5063 25.2587 19.3733 25.1667 19.2614 25.0432C19.1496 24.9225 19.0589 24.7656 19.035 24.5896C19.0125 24.4136 19.0589 24.2383 19.1353 24.0931C19.211 23.9451 19.3153 23.8209 19.4272 23.7097C19.4818 23.6518 19.5425 23.6027 19.6004 23.5501C19.6618 23.5031 19.7212 23.4512 19.7853 23.4083C19.848 23.3626 19.9115 23.3182 19.9769 23.278C20.0411 23.235 20.1072 23.1961 20.1734 23.1573C20.7054 22.8496 21.2743 22.6246 21.8492 22.4295C23.004 22.0496 24.1976 21.8136 25.3981 21.6635C26.5992 21.5189 27.8133 21.4643 29.0192 21.5503C29.6215 21.5946 30.2238 21.6737 30.807 21.8333C30.88 21.8538 30.9523 21.8736 31.0239 21.8981C31.0962 21.9206 31.1671 21.9466 31.2374 21.9732C31.309 21.9984 31.3765 22.0318 31.4461 22.0605C31.5129 22.0953 31.5825 22.126 31.6466 22.1662C31.7769 22.2419 31.9024 22.3299 32.0033 22.4424C32.1036 22.5536 32.1814 22.6914 32.2011 22.8421ZM32.2011 22.8421C32.1807 22.6914 32.1022 22.555 32.0006 22.4445C31.899 22.3326 31.7735 22.2446 31.6432 22.1703C31.5791 22.1307 31.5095 22.1 31.4427 22.0659C31.3731 22.0373 31.3049 22.0039 31.234 21.9793C31.1637 21.9527 31.0928 21.9268 31.0205 21.905C30.9488 21.8811 30.8759 21.8613 30.8036 21.8408C30.2204 21.6846 29.6174 21.6164 29.0165 21.5789C27.8113 21.5134 26.6026 21.5973 25.4104 21.7645C24.2188 21.9377 23.0381 22.2003 21.9045 22.5959C21.3391 22.7944 20.7832 23.0256 20.2716 23.3271C20.2082 23.3653 20.1441 23.4028 20.0827 23.4437C20.0199 23.4833 19.9599 23.5256 19.9005 23.5692C19.8398 23.6108 19.7853 23.6593 19.7273 23.7036C19.6741 23.7527 19.6168 23.7984 19.5684 23.8516C19.4674 23.9532 19.3754 24.0644 19.3146 24.1865C19.2526 24.3072 19.2205 24.4382 19.2369 24.5637C19.2539 24.6892 19.3187 24.8065 19.4101 24.9075C19.5009 25.0091 19.6182 25.0923 19.743 25.1646C19.8037 25.2028 19.8705 25.2321 19.9353 25.2656C20.0029 25.2935 20.0683 25.3263 20.1379 25.3501C20.2068 25.3767 20.2757 25.402 20.3466 25.4238C20.4162 25.4477 20.4878 25.4675 20.5594 25.4872C21.1324 25.6441 21.7292 25.7225 22.3267 25.7669C23.5237 25.8521 24.7324 25.7983 25.9274 25.6543C27.1224 25.505 28.3106 25.2703 29.4565 24.8931C30.0274 24.7001 30.5908 24.4771 31.1132 24.1742C31.178 24.136 31.2435 24.0978 31.3063 24.0556C31.3704 24.0153 31.4318 23.9723 31.4931 23.928C31.5559 23.8857 31.6125 23.8359 31.6725 23.7902C31.7285 23.7397 31.7871 23.692 31.839 23.6374C31.9454 23.531 32.0436 23.4137 32.1125 23.2793C32.1807 23.145 32.2202 22.9929 32.2011 22.8421Z",
    fill: "url(#paint31_linear_4014_279705)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 17,
    width: 17,
    height: 18
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.502 25.6392C21.502 25.6392 24.0884 24.7511 26.979 22.4511C29.3274 20.5829 31.3068 17.9951 31.3068 17.9951L36.8808 27.9228C36.8808 27.9228 37.2013 28.8033 36.8276 29.5775C36.4538 30.3516 34.3455 32.567 32.984 33.3405C31.6233 34.1147 29.4611 34.6221 29.4611 34.6221L23.8026 28.7235L21.502 25.6392Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0478 29.2222C35.3882 29.6854 34.4776 30.9322 33.0139 32.0078C31.5501 33.0835 30.0884 33.58 29.7481 33.1169C29.4077 32.6538 30.3183 31.4069 31.782 30.3313C33.2458 29.2556 34.7081 28.7591 35.0478 29.2222Z",
    fill: "url(#paint32_linear_4014_279705)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_4014_279705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 17,
    width: 17,
    height: 18
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.502 25.6392C21.502 25.6392 24.0884 24.7511 26.979 22.4511C29.3274 20.5829 31.3068 17.9951 31.3068 17.9951L36.8808 27.9228C36.8808 27.9228 37.2013 28.8033 36.8276 29.5775C36.4538 30.3516 34.3455 32.567 32.984 33.3405C31.6233 34.1147 29.4611 34.6221 29.4611 34.6221L23.8026 28.7235L21.502 25.6392Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_4014_279705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0478 29.2225C35.041 29.2137 35.0335 29.2055 35.026 29.1973L35.054 29.1768C35.054 29.1768 33.801 27.1306 32.93 25.1014C31.7432 22.3356 31.3748 17.3032 31.3748 17.3032L25.9653 22.352L19.5312 26.0072C19.5312 26.0072 24.2239 27.8611 26.5089 29.82C27.9692 31.0716 29.3545 32.6036 29.6881 32.978C29.699 33.0299 29.7188 33.0763 29.7488 33.1165C30.0891 33.5796 31.5515 33.0831 33.0146 32.0075C34.4776 30.9332 35.3882 29.6857 35.0478 29.2225Z",
    stroke: "url(#paint33_radial_4014_279705)",
    strokeWidth: 0.118227,
    strokeMiterlimit: 10
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5833 24.0515L29.4053 24.8188L28.5002 23.7206C28.4395 23.6381 28.3229 23.6204 28.2404 23.6811L27.5058 24.2213L27.2895 24.3802L26.5549 24.9204C26.4724 24.9811 26.4547 25.0978 26.5154 25.1803L27.2929 26.3719L26.2084 27.2668C26.1259 27.3275 26.1082 27.4441 26.1689 27.5266L27.2732 29.0293C27.3339 29.1118 27.4505 29.1295 27.533 29.0688L28.711 28.3015L29.5472 29.3055C29.6079 29.388 29.7246 29.4058 29.8071 29.3451L30.5253 28.8171L30.775 28.6337L31.4932 28.1057C31.5757 28.045 31.5934 27.9284 31.5327 27.8459L30.8241 26.7484L31.9086 25.8535C31.9911 25.7928 32.0088 25.6762 31.9481 25.5936L30.8438 24.091C30.7825 24.0085 30.6658 23.9908 30.5833 24.0515Z",
    fill: "url(#paint34_linear_4014_279705)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9553 19.1499C30.9553 19.1499 30.0297 20.5025 28.6779 21.6054C26.7415 23.1851 25.7954 23.7403 25.7954 23.7403L28.7768 26.6466C29.6348 27.4835 30.4226 28.3893 31.132 29.3551L33.02 31.9252C33.02 31.9252 34.1945 31.3557 34.835 29.9322C34.985 29.5986 30.9199 25.1283 30.9553 19.1499Z",
    fill: "url(#paint35_linear_4014_279705)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3174 10.2397L20.2933 14.457L20.6268 14.2033L17.5575 10.3066L17.3174 10.2397Z",
    fill: "url(#paint36_linear_4014_279705)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8809 9.76727C17.1237 9.89891 17.3502 10.0701 17.3399 10.0899C17.329 10.1097 17.0767 10.0326 16.8345 9.90096C16.5917 9.76932 16.4028 9.60289 16.413 9.58311C16.4232 9.56401 16.6381 9.63631 16.8809 9.76727Z",
    fill: "#1B1464"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4014_279705",
    x: 0.0771484,
    y: 0.226562,
    width: 61.959,
    height: 52.5234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_4014_279705"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4014_279705",
    x: 0.0771484,
    y: 13.7002,
    width: 50.3184,
    height: 39.0498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_4014_279705"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4014_279705",
    x: 15.5361,
    y: 12.0181,
    width: 46.5,
    height: 37.4419,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_4014_279705"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4014_279705",
    x: 2.46924,
    y: 0.226562,
    width: 52.4531,
    height: 45.5098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_4014_279705"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4014_279705",
    x1: 33.8114,
    y1: 42.2166,
    x2: 42.804,
    y2: 35.2501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6DA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0369,
    stopColor: "#965B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0968,
    stopColor: "#904266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1519,
    stopColor: "#8C2F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#892439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    stopColor: "#882033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    stopColor: "#892134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3715,
    stopColor: "#B83C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4728,
    stopColor: "#D54D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5307,
    stopColor: "#E05367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5787,
    stopColor: "#E05A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6483,
    stopColor: "#DF6D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6564,
    stopColor: "#DF7082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    stopColor: "#DC5164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9444,
    stopColor: "#A82A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#951C2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4014_279705",
    x1: 31.5888,
    y1: 37.4486,
    x2: 42.6083,
    y2: 37.4486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0321,
    stopColor: "#B56D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1375,
    stopColor: "#BB566E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2604,
    stopColor: "#C23F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3296,
    stopColor: "#C43744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4566,
    stopColor: "#BD3442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#AA2D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8596,
    stopColor: "#8A2134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8726,
    stopColor: "#882033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4014_279705",
    x1: 34.2863,
    y1: 37.0358,
    x2: 38.241,
    y2: 37.5573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#950044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2376,
    stopColor: "#84133A",
    stopOpacity: 0.5272
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4507,
    stopColor: "#792033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4014_279705",
    x1: 35.2121,
    y1: 37.9026,
    x2: 38.5836,
    y2: 35.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6DA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0369,
    stopColor: "#965B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0968,
    stopColor: "#904266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1519,
    stopColor: "#8C2F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#892439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    stopColor: "#882033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    stopColor: "#892134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3715,
    stopColor: "#B83C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4728,
    stopColor: "#D54D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5307,
    stopColor: "#E05367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5787,
    stopColor: "#E05A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6483,
    stopColor: "#DF6D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6564,
    stopColor: "#DF7082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    stopColor: "#DC5164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#A83446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E1C2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4014_279705",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0158 35.6219) rotate(-32.3011) scale(2.82073 1.49898)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E1C2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6315,
    stopColor: "#811D2F",
    stopOpacity: 0.3685
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#882033",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4014_279705",
    x1: 22.6682,
    y1: 31.4208,
    x2: 35.7141,
    y2: 22.0786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00837989,
    stopColor: "#67B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0649,
    stopColor: "#65B4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0852,
    stopColor: "#5EB3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0997,
    stopColor: "#53B2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1114,
    stopColor: "#42B0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1186,
    stopColor: "#33AFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2486,
    stopColor: "#498AC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2591,
    stopColor: "#4F8AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#568BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    stopColor: "#588BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4939,
    stopColor: "#5EACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6814,
    stopColor: "#67DDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6915,
    stopColor: "#5CEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7063,
    stopColor: "#53F6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7271,
    stopColor: "#4DFDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    stopColor: "#4CFFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9693,
    stopColor: "#32EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4014_279705",
    x1: 32.3256,
    y1: 26.435,
    x2: 35.9127,
    y2: 23.8663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0307,
    stopColor: "#CDFFFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1715,
    stopColor: "#CFFFFF",
    stopOpacity: 0.5268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9916,
    stopColor: "#DAFFFF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_4014_279705",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.269 23.6094) rotate(-37.1517) scale(7.46943 10.8188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0307,
    stopColor: "#6EEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3255,
    stopColor: "#71ECFF",
    stopOpacity: 0.6932
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    stopColor: "#7BF0FF",
    stopOpacity: 0.4497
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7727,
    stopColor: "#8CF6FF",
    stopOpacity: 0.2279
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9723,
    stopColor: "#A3FEFF",
    stopOpacity: 0.0201
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9916,
    stopColor: "#A6FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4014_279705",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5401 32.4329) rotate(-35.2274) scale(6.16886 2.47168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0307,
    stopColor: "#6EEBFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3255,
    stopColor: "#71ECFF",
    stopOpacity: 0.4159
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5595,
    stopColor: "#7BF0FF",
    stopOpacity: 0.2698
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7727,
    stopColor: "#8CF6FF",
    stopOpacity: 0.1367
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9723,
    stopColor: "#A3FEFF",
    stopOpacity: 0.0121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9916,
    stopColor: "#A6FFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4014_279705",
    x1: 23.2313,
    y1: 26.4166,
    x2: 33.9726,
    y2: 40.9637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498AC9",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2794,
    stopColor: "#407BC3",
    stopOpacity: 0.8098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5329,
    stopColor: "#3B72BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA3341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4014_279705",
    x1: 20.675,
    y1: 30.7242,
    x2: 29.4078,
    y2: 30.7242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83ECC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3144,
    stopColor: "#7FDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7367,
    stopColor: "#7AD2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4014_279705",
    x1: 30.2798,
    y1: 23.6252,
    x2: 37.922,
    y2: 23.6252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0307,
    stopColor: "#3275C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1699,
    stopColor: "#327ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6998,
    stopColor: "#339CDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4014_279705",
    x1: 17.4566,
    y1: 20.2232,
    x2: 31.2538,
    y2: 20.2232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ED8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4014_279705",
    x1: 17.252,
    y1: 19.8824,
    x2: 31.0492,
    y2: 19.8824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1699DB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000874192,
    stopColor: "#199DD9",
    stopOpacity: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001745,
    stopColor: "#21A9D5",
    stopOpacity: 0.6247
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0026122,
    stopColor: "#2EBDCD",
    stopOpacity: 0.9352
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0027933,
    stopColor: "#32C2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D72DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_4014_279705",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1516 19.8823) rotate(-33.8124) scale(8.32577 2.81567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55CEE9",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2434,
    stopColor: "#53CAE7",
    stopOpacity: 0.554
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4802,
    stopColor: "#4DBEE2",
    stopOpacity: 0.4119
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7142,
    stopColor: "#43ABDA",
    stopOpacity: 0.2715
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9454,
    stopColor: "#3690CE",
    stopOpacity: 0.1328
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3288CB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4014_279705",
    x1: 20.8705,
    y1: 17.5414,
    x2: 25.5569,
    y2: 20.0153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00376425,
    stopColor: "#3231D4",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2935,
    stopColor: "#2D30AE",
    stopOpacity: 0.5036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5844,
    stopColor: "#29308E",
    stopOpacity: 0.708
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8303,
    stopColor: "#272F7B",
    stopOpacity: 0.8808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262F74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4014_279705",
    x1: 17.3934,
    y1: 19.8216,
    x2: 24.4312,
    y2: 15.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00991153,
    stopColor: "#5383CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    stopColor: "#5180C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2464,
    stopColor: "#4C78BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3449,
    stopColor: "#436BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3516,
    stopColor: "#426AAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4418,
    stopColor: "#426BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4747,
    stopColor: "#406FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4981,
    stopColor: "#3E76C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#3B7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5216,
    stopColor: "#3D80CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6923,
    stopColor: "#56AAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7793,
    stopColor: "#60BBF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8985,
    stopColor: "#63B9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    stopColor: "#6DB1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EB1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4014_279705",
    x1: 25.6371,
    y1: 16.9249,
    x2: 19.6023,
    y2: 15.4854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4014_279705",
    x1: 21.5117,
    y1: 19.7504,
    x2: 16.6438,
    y2: 16.4698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41FFDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23FFFF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4014_279705",
    x1: 18.4224,
    y1: 14.0847,
    x2: 21.9287,
    y2: 14.8052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0068B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#435390"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4014_279705",
    x1: 19.3206,
    y1: 14.277,
    x2: 20.7511,
    y2: 14.0351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00376425,
    stopColor: "#3231D4",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2935,
    stopColor: "#2D30AE",
    stopOpacity: 0.5036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5844,
    stopColor: "#29308E",
    stopOpacity: 0.708
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8303,
    stopColor: "#272F7B",
    stopOpacity: 0.8808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262F74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4014_279705",
    x1: 17.5612,
    y1: 12.1517,
    x2: 18.9386,
    y2: 11.2194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00991153,
    stopColor: "#00CCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0516,
    stopColor: "#02C9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859,
    stopColor: "#09BFCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1176,
    stopColor: "#15ADC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1478,
    stopColor: "#2595BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1765,
    stopColor: "#3A76B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1862,
    stopColor: "#426AAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319,
    stopColor: "#426BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    stopColor: "#406FB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4019,
    stopColor: "#3E76C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4223,
    stopColor: "#3B7DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4307,
    stopColor: "#3D80CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5809,
    stopColor: "#56AAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6575,
    stopColor: "#60BBF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#5FBEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7766,
    stopColor: "#5BC8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8017,
    stopColor: "#58D0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#48C3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32B1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4014_279705",
    x1: 16.751,
    y1: 10.6317,
    x2: 16.9405,
    y2: 9.14933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1714,
    stopColor: "#D9F5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5563,
    stopColor: "#77DCD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4014_279705",
    x1: 39.1005,
    y1: 30.5249,
    x2: 46.4292,
    y2: 30.5249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33B0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0554,
    stopColor: "#37B5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6906,
    stopColor: "#67EAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AFFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4014_279705",
    x1: 38.9865,
    y1: 32.3223,
    x2: 48.1588,
    y2: 29.4923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1173,
    stopColor: "#538EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2524,
    stopColor: "#5192BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3968,
    stopColor: "#4A9FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5452,
    stopColor: "#3FB4C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682,
    stopColor: "#31CFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9749,
    stopColor: "#3395D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4014_279705",
    x1: 26.4568,
    y1: 32.03,
    x2: 39.9665,
    y2: 31.2761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33C8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1388,
    stopColor: "#33F692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7905,
    stopColor: "#329ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#329ECC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4014_279705",
    x1: 25.4843,
    y1: 39.938,
    x2: 30.0787,
    y2: 41.1874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#499CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2475,
    stopColor: "#4596C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#3884CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7096,
    stopColor: "#327CCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4014_279705",
    x1: 26.6117,
    y1: 45.055,
    x2: 31.5042,
    y2: 36.6547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2692,
    stopColor: "#358CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3941,
    stopColor: "#3F9DCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6415,
    stopColor: "#59C7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682,
    stopColor: "#5ECFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9749,
    stopColor: "#3395D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_4014_279705",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2929 25.1841) scale(7.8211)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1699DB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3668,
    stopColor: "#1A96D9",
    stopOpacity: 0.3784
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7317,
    stopColor: "#268ED2",
    stopOpacity: 0.7549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9693,
    stopColor: "#3285CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4014_279705",
    x1: 25.3319,
    y1: 20.7619,
    x2: 29.6161,
    y2: 35.6817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1154,
    stopColor: "#009B0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4274,
    stopColor: "#35E327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6547,
    stopColor: "#7BFF48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7226,
    stopColor: "#7AFF4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7745,
    stopColor: "#79FF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#76FF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8644,
    stopColor: "#72FF7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9057,
    stopColor: "#6CFF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    stopColor: "#66FFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#5EFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4014_279705",
    x1: 19.1292,
    y1: 23.7094,
    x2: 32.2063,
    y2: 23.7094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1263,
    stopColor: "#089804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3241,
    stopColor: "#1EA810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5686,
    stopColor: "#43C124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#75E53E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9693,
    stopColor: "#8DF64B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4014_279705",
    x1: 19.0278,
    y1: 23.7371,
    x2: 32.3095,
    y2: 23.7371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0307,
    stopColor: "#8DF64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9413,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4014_279705",
    x1: 33.1331,
    y1: 32.3422,
    x2: 30.8583,
    y2: 28.7121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0307,
    stopColor: "#00E30E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9022,
    stopColor: "#00FF8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_4014_279705",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2585 25.2381) scale(8.05963 8.05963)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13FF16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#73FF74",
    stopOpacity: 0.9741
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3688,
    stopColor: "#BEFFBF",
    stopOpacity: 0.9517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    stopColor: "#EDFFED",
    stopOpacity: 0.9359
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5503,
    stopColor: "white",
    stopOpacity: 0.928
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#B0FFFF",
    stopOpacity: 0.9541
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8859,
    stopColor: "#56FFFF",
    stopOpacity: 0.9857
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9693,
    stopColor: "#32FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4014_279705",
    x1: 27.8459,
    y1: 29.6305,
    x2: 29.9132,
    y2: 24.1571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F12563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2025,
    stopColor: "#F32B64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F93D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#FF5069"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4014_279705",
    x1: 32.4458,
    y1: 32.772,
    x2: 28.7678,
    y2: 22.4768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4014_279705",
    x1: 18.7392,
    y1: 12.393,
    x2: 19.2132,
    y2: 12.0721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevive);
export default __webpack_public_path__ + "static/media/revive.5103ca676e58f5e40e9fe50fa743b3c7.svg";
export { ForwardRef as ReactComponent };